/* dtf-transfers — size-guide scale-to-fit + Enlarge modal (desktop only).
   Loaded only on /products/dtf-transfers (theme.liquid handle gate).

   IN-PAGE: the size-guide mockups are fixed-px artwork built for ~528px, so we
   render the card at native width and transform-scale it to fit the 30% column
   (scale UP for Enlarge), keeping everything aligned.

   ENLARGE MODAL (standard lightbox: page untouched, dim overlay, lit modal):
   the size-guide column (.element--is-sticky) is `position:sticky !important`,
   creating its OWN stacking context — so the card can't be lifted above a
   product-page-level backdrop by z-index alone, and it can't be moved to <body>
   (its mockups are revealed by product-page-scoped CSS, so they'd render blank
   there). Instead: lift product-page above the header, drop a dim backdrop INSIDE
   product-page, and NEUTRALIZE the column's sticky context (position:relative via
   setProperty important) so the CARD alone rises above the backdrop. Everything
   else — the other column, the VIVID-AF video — just dims like a normal lightbox.
   Nothing is hidden, moved, blurred, or erased. */
(function () {
  'use strict';
  if (window.__ntDtf3colInit) return;
  window.__ntDtf3colInit = true;

  var NATIVE_W = 528;        // in-page: scale the size guide to fit the column at its native artwork width
  var ENLARGE_W = 588;       // enlarged: card border-box width so content == 528 (mockups perfect) + the swatches fit one line
  var DESKTOP_MIN = 1024;
  var SG_SEL = '.dtf_imgix_images';

  var ENLARGE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>';
  var CLOSE_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  var backdrop = null, closeBtn = null, enlarged = false;
  var ntOrigPricesParent = null;   // where the real prices-table lived before we relocated it to col 3

  function sgEl()  { return document.querySelector(SG_SEL); }
  function colEl() { var s = sgEl(); return s ? (s.closest('.element--is-sticky') || s.parentElement) : null; }
  function ppEl()  { var s = sgEl(); return s ? (s.closest('product-page') || s.closest('.grid--layout')) : null; }
  function isDesktop() { return window.innerWidth >= DESKTOP_MIN; }

  // ── Preview: ~1/4" of transparent breathing room around each design ──
  // The art is fetched trimmed, so its print-area box (preview-block: the gray
  // dotted-bordered canvas) renders edge-to-edge in the preview and it's unclear
  // where the design stops. Scale that box + its dimension rulers down together
  // so transparent margin shows AROUND the box (file-preview behind it is
  // transparent -> the page shows through). Because the rulers scale WITH the
  // box, they still read the true size and the print/cost are unchanged.
  // scale = 1 - 0.5/maxInches keeps the margin a constant ~1/4" each side at ANY
  // design size (the box px is proportional to inches either way, so the ratio
  // holds). A fixed scale can't do that. CSS supplies a 0.93 no-JS fallback.
  var PREVIEW_PAD = 44; // px of breathing room (W/H rulers + ~1/2") inside the square preview
  function readBlockInches(pb) {
    function rd(re) {
      var kids = pb.querySelectorAll('div'), el = null;
      for (var i = 0; i < kids.length; i++) { if (re.test((kids[i].className || '') + '')) { el = kids[i]; break; } }
      if (!el) return 0;
      var c = (getComputedStyle(el, '::before').content || '').match(/([0-9]+(?:\.[0-9]+)?)/);
      return c ? parseFloat(c[1]) : 0;
    }
    return Math.max(rd(/horizontal_direction/), rd(/verticle_direction/));
  }
  function applyPreviewMargin() {
    var blocks = document.querySelectorAll('preview-box preview-block');
    for (var i = 0; i < blocks.length; i++) {
      var pb = blocks[i];
      var fp = pb.closest('file-preview');
      if (!fp) continue;
      // Power Builder cards (multi view on the power-builder template) show the
      // art full-box minus its own 6px pad — no breathing-room scale (Justin
      // 7-6; PAD=44 is tuned for the ~440px single preview and crushes 137px
      // thumbs). Clear any transform a pre-builder tick already applied.
      if (document.body.classList.contains('pb-builder-open') && pb.closest('uploaded-files-block')) {
        if (pb.style.transform) { pb.style.transform = ''; pb.style.transformOrigin = ''; }
        continue;
      }
      // Fill the file-preview's LARGER dimension (minus PAD) with the print box. For a
      // WIDE design the frame is wide-short (mobile/multi size the frame to the art), so
      // the larger side is the WIDTH and the design goes max-width, leaving ~1/2" (PAD)
      // side padding for the height arrows + measurement (Justin's rule). max() not min()
      // is the fix: min() grabbed the SHORT side and crushed wide art to ~20% width. On a
      // square frame max==min, so desktop is unchanged. The smaller dimension fits inside
      // the frame (no overflow) because the frame's aspect tracks the art's; top/bottom
      // slack on a square frame is fine (Justin doesn't care about it). Runs at ALL widths
      // (single + multi). offsetW/H is the layout size (transform-independent).
      var box = Math.max(fp.clientWidth, fp.clientHeight);
      var avail = box - 2 * PREVIEW_PAD;
      var natW = pb.offsetWidth, natH = pb.offsetHeight;
      if (!natW || !natH || avail <= 0) continue;
      var scale = Math.min(avail / natW, avail / natH, 1);
      if (scale < 0.2) scale = 0.2;
      var want = 'scale(' + (Math.round(scale * 1000) / 1000) + ')';
      // Guard on the actual inline transform: skip when already correct (so the
      // subtree observer doesn't loop on our own writes), but re-apply if the
      // engine wiped it on a resize (self-healing).
      if (pb.style.transform === want) continue;
      pb.style.transformOrigin = 'center center';
      pb.style.transform = want;
    }
    placeUploadIcons();
  }

  // The engine updates the dimension rulers ASYNChronously after a size change,
  // and via several paths (W/H inputs, popular-size picks, auto-fit). Watch the
  // whole preview-box subtree so we recompute once the new size lands, whatever
  // the trigger. Loop-safe via the idempotency guard above. Attached lazily
  // because preview-box only exists after upload.
  var previewObserverOn = false;
  function ensurePreviewObserver() {
    if (previewObserverOn) return;
    var pbox = document.querySelector('preview-box');
    if (!pbox || !window.MutationObserver) return;
    previewObserverOn = true;
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { applyPreviewMargin(); arrangeBgOptions(); }, 120); })
      .observe(pbox, { attributes: true, childList: true, characterData: true, subtree: true });
  }

  // ── #3: BG-removal options → vertical column LEFT of the preview (desktop) ──
  // When Remove Background is on, the engine (bg-removal-multi.js — untouched per
  // the deploy rule) renders an options card .nt-bgr-tabs (header + the 3 option
  // thumbnails) inside .ai-wrap, BELOW the preview. Relocate the WHOLE card (NOT
  // just the thumbnails — pulling the thumbnails OUT of the card breaks the
  // engine's image population, which queries inside .nt-bgr-tabs) to the LEFT of
  // the preview image; CSS (.nt-bgr-split-on) hides its header + stacks the
  // thumbnails. Restored on BG-off / mobile; re-applied if the engine re-renders.
  // Banner = the card's HEADER row ("NEW · 3 Background Removal options · Show/Hide").
  // Justin wants it pinned on TOP of the Remove-Background tools box (whether the 3
  // thumbnails are Shown or Hidden), with Show/Hide controlling the thumbnails on the
  // LEFT of the preview. Mechanics learned from the engine: the Hide button toggles
  // .is-collapsed on the card via a GLOBAL lookup, so it keeps working after we move
  // the header out; and the 3 thumbnails must stay INSIDE the card (the engine
  // populates them + collapses them by querying inside .nt-bgr-tabs). So we move only
  // the HEADER to the tools box and keep the buttons in the card on the left; CSS
  // (.is-collapsed) hides the left thumbnails when Hidden.
  function arrangeBgOptions() {
    /* REVERTED (boss, 2026-06-23): BG-removal options now display in the engine-DEFAULT
       position UNDER the image, not split to the left. No-op so the card is never
       relocated and .nt-bgr-split-on is never added (the split CSS goes inert). The
       header also stays in the card (not pinned to the tools box). */
    return;
    /* (unreachable below — kept for reference / quick re-enable) */
    var sticky = document.querySelector('.previewBlock_and_pricesTable .stickyBox');
    if (!sticky) return;
    var fp = sticky.querySelector('file-preview');
    var toolsBox = document.querySelector('.previewBlock_and_pricesTable .ai-ring');
    var engineCard = document.querySelector('.previewBlock_and_pricesTable .ai-wrap .nt-bgr-tabs');
    var movedCard = sticky.querySelector(':scope > .nt-bgr-tabs');
    var card = engineCard || movedCard;
    var bgToggle = document.querySelector('#bgRemover');
    var desktop = isDesktop();

    // No options card yet, or mobile -> restore the engine default (header back in the
    // card, card in .ai-wrap, no split).
    if (!desktop || !card) {
      var h0 = document.querySelector('.previewBlock_and_pricesTable .nt-bgr-tabs__header-row');
      if (h0 && card && h0.parentElement !== card) card.insertBefore(h0, card.firstChild);
      if (movedCard && movedCard.__ntOrig) movedCard.__ntOrig.appendChild(movedCard);
      sticky.classList.remove('nt-bgr-split-on');
      return;
    }

    // Banner: pin the card's header on top of the tools box — ALWAYS, whether Remove
    // Background is on or off (Justin). Only the header moves; the thumbnails stay in
    // the card so the engine keeps populating/collapsing them and the Hide button
    // (global handler) keeps toggling .is-collapsed. Handle engine re-renders by
    // dropping the orphaned header we moved previously.
    var cardHeader = card.querySelector('.nt-bgr-tabs__header-row');
    var pinnedHeader = toolsBox && toolsBox.querySelector(':scope > .nt-bgr-tabs__header-row');
    if (cardHeader && toolsBox) {
      if (pinnedHeader && pinnedHeader !== cardHeader) pinnedHeader.remove();
      toolsBox.insertBefore(cardHeader, toolsBox.firstChild);
    }

    // Thumbnails: relocate the card (buttons) to the LEFT of the preview only when BG
    // is on; otherwise keep it in .ai-wrap. (Show/Hide -> .is-collapsed -> CSS hides
    // the left column.)
    var bgOn = !!(bgToggle && bgToggle.checked);
    if (bgOn) {
      if (engineCard && engineCard !== movedCard) {        // (re)rendered -> relocate fresh card left
        if (movedCard) movedCard.remove();
        engineCard.__ntOrig = engineCard.parentElement;
        sticky.insertBefore(engineCard, fp);
      }
      sticky.classList.add('nt-bgr-split-on');
    } else {
      if (movedCard && movedCard.__ntOrig) movedCard.__ntOrig.appendChild(movedCard);
      sticky.classList.remove('nt-bgr-split-on');
    }
  }

  // ── Req 5: move the zoom + trash icons OFF the design to the print-preview
  // (file-preview) upper corners. They render inside preview-block, which is
  // transform-scaled — a transform makes that element the containing block for its
  // absolute children, so CSS alone can't reposition them relative to file-preview.
  // Relocate them in the DOM onto file-preview (position:absolute via CSS, so they
  // stay OUT of file-preview's flex flow and don't disturb the centered preview) and
  // pin them to the top corners. Runs at ALL widths now and for EVERY design preview —
  // the single preview AND each multi-upload "Upload N" (Justin). pb.querySelector finds
  // only un-moved icons, so once relocated they're skipped; if the engine re-renders one
  // inside preview-block we drop the stale moved copy and move the fresh one. DOM move
  // preserves their click handlers (View-full-image / delete).
  function placeUploadIcons() {
    var fps = document.querySelectorAll('.previewBlock_and_pricesTable file-preview, multi-upload file-preview');
    for (var k = 0; k < fps.length; k++) {
      var fp = fps[k];
      fp.style.position = 'relative';
      // Search the WHOLE file-preview: the icons sit INSIDE preview-block on the single
      // preview, but are DIRECT children of file-preview in the multi-upload modal. Skip
      // an icon that's already our relocated direct child (so we don't re-append every
      // tick); if the engine re-rendered a fresh copy, document order surfaces it first
      // and we swap our stale one out.
      var zoom = fp.querySelector('a.zoom_image');
      if (zoom && !(zoom.parentElement === fp && zoom.classList.contains('nt-fp-icon'))) {
        var oldZ = fp.querySelector(':scope > .nt-fp-icon--zoom');
        if (oldZ && oldZ !== zoom) oldZ.remove();
        zoom.classList.add('nt-fp-icon', 'nt-fp-icon--zoom');
        fp.appendChild(zoom);
      }
      var trash = fp.querySelector('.upload_tools');
      if (trash && !(trash.parentElement === fp && trash.classList.contains('nt-fp-icon'))) {
        var oldT = fp.querySelector(':scope > .nt-fp-icon--trash');
        if (oldT && oldT !== trash) oldT.remove();
        trash.classList.add('nt-fp-icon', 'nt-fp-icon--trash');
        fp.appendChild(trash);
      }
    }
  }

  // ── Main-preview loader while BG removal processes (desktop) ──
  // When Remove Background is switched on, the engine regenerates the main preview +
  // the 3 option thumbnails (takes a few seconds). Show a spinner over the main
  // preview so the user sees it working; clear it once the option thumbnails have
  // loaded (engine done), on toggle-off, or after a safety timeout.
  var bgLoadPoll = null, bgLoadN = 0;
  function previewLoading(on) {
    var fp = document.querySelector('.previewBlock_and_pricesTable file-preview');
    if (!fp) return;
    if (on) fp.style.position = 'relative';
    fp.classList.toggle('nt-bgr-loading', !!on);
  }
  function startBgLoad() {
    if (!isDesktop()) return;
    previewLoading(true);
    bgLoadN = 0;
    clearInterval(bgLoadPoll);
    bgLoadPoll = setInterval(function () {
      var cb = document.querySelector('#bgRemover');
      if (!cb || !cb.checked) { previewLoading(false); clearInterval(bgLoadPoll); return; }
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.nt-bgr-tabs__buttons .nt-bgr-tab__thumb'));
      var done = thumbs.length >= 3 && thumbs.every(function (i) { return i.complete && i.naturalWidth > 0; });
      if (done || ++bgLoadN >= 75) { previewLoading(false); clearInterval(bgLoadPoll); } // ~30s max
    }, 400);
  }

  function clearStyles(s) {
    s.style.width = ''; s.style.transform = ''; s.style.transformOrigin = '';
    s.style.marginBottom = ''; s.style.marginLeft = ''; s.style.position = ''; s.style.top = '';
    s.style.left = ''; s.style.zIndex = '';
  }

  // Scale the size guide DOWN from native width to fit the (30%) column.
  function fitInPage() {
    var s = sgEl(); if (!s || enlarged) return;
    if (!isDesktop()) { clearStyles(s); return; }
    var c = colEl(); if (!c) return;
    s.style.position = ''; s.style.top = ''; s.style.left = ''; s.style.zIndex = '';
    s.style.width = NATIVE_W + 'px';
    s.style.transformOrigin = 'top left';
    s.style.transform = 'none';
    s.style.marginBottom = '0px';
    // Full-width: the grey header/mockup area reaches the card edges (no side inset).
    // The earlier marginLeft+narrower-avail shrank the WHOLE card, leaving corner gaps;
    // instead we pad only the swatch row in CSS so the swatches don't clip the edge.
    s.style.marginLeft = '0px';
    var avail = c.clientWidth;
    if (avail <= 0) return;
    var scale = avail / NATIVE_W;
    if (scale >= 0.999) { clearStyles(s); return; }
    var h = s.offsetHeight;
    s.style.transform = 'scale(' + (Math.round(scale * 10000) / 10000) + ')';
    s.style.marginBottom = (-Math.round(h * (1 - scale))) + 'px';
  }

  function ensureChrome() {
    if (backdrop) return;
    backdrop = document.createElement('div');
    backdrop.className = 'nt-sg-backdrop';
    backdrop.addEventListener('click', closeEnlarge);
    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'nt-sg-close';
    closeBtn.setAttribute('aria-label', 'Close size guide');
    closeBtn.innerHTML = CLOSE_SVG;
    closeBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); closeEnlarge(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeEnlarge(); });
  }

  function openEnlarge() {
    var s = sgEl(); if (!s) return;
    ensureChrome();
    enlarged = true;
    var pp = ppEl(), col = colEl();
    // Backdrop + close live inside product-page; lift product-page above the
    // header so the dim covers the whole page.
    if (pp) { pp.appendChild(backdrop); pp.appendChild(closeBtn); pp.style.zIndex = '2147483000'; }
    // Neutralize the size-guide column's OWN stacking context (it's position:sticky)
    // so the CARD alone can rise above the backdrop — the column's other content
    // (the VIVID-AF video etc.) stays at its normal z and is simply DIMMED by the
    // backdrop like the rest of the page. Nothing is hidden or moved; the page is
    // untouched apart from the dim overlay (standard lightbox).
    // NB: the column has `position:sticky !important`, so a plain inline write is
    // ignored — must use setProperty with priority to neutralize its context.
    if (col) { col.style.setProperty('position', 'relative', 'important'); col.style.zIndex = 'auto'; col.style.overflow = 'visible'; }
    // size the card at ENLARGE_W (content == native 528 so mockups + swatches
    // get their designed width), then scale to a contained card.
    s.classList.add('nt-sg-enlarged');
    s.style.position = ''; s.style.transform = 'none'; s.style.transformOrigin = 'center center';
    s.style.width = ENLARGE_W + 'px'; s.style.marginBottom = '0px'; s.style.marginLeft = '0px';
    var h = s.offsetHeight;
    var maxW = Math.min(1000, window.innerWidth * 0.92);
    var scale = Math.min(maxW / ENLARGE_W, (window.innerHeight * 0.9) / h);
    if (scale < 0.2) scale = 0.2;
    s.style.position = 'fixed'; s.style.top = '50%'; s.style.left = '50%'; s.style.zIndex = '2147483646';
    s.style.transform = 'translate(-50%, -50%) scale(' + (Math.round(scale * 10000) / 10000) + ')';
    // Put the X in the card's own top-right corner (computed from its rect),
    // not the viewport corner.
    var cr = s.getBoundingClientRect();
    closeBtn.style.top = Math.max(8, Math.round(cr.top + 12)) + 'px';
    closeBtn.style.right = Math.max(8, Math.round(window.innerWidth - cr.right + 12)) + 'px';
    backdrop.classList.add('is-open');
    closeBtn.classList.add('is-open');
    document.body.classList.add('nt-sg-lightbox-open');
  }

  function closeEnlarge() {
    if (!enlarged) return;
    enlarged = false;
    var s = sgEl();
    if (s) s.classList.remove('nt-sg-enlarged');
    if (backdrop) backdrop.classList.remove('is-open');
    if (closeBtn) { closeBtn.classList.remove('is-open'); closeBtn.style.top = ''; closeBtn.style.right = ''; }
    var pp = ppEl(); if (pp) pp.style.zIndex = '';
    var col = colEl(); if (col) { col.style.position = ''; col.style.zIndex = ''; col.style.overflow = ''; }
    document.body.classList.remove('nt-sg-lightbox-open');
    fitInPage();
  }

  function injectButton() {
    if (!isDesktop()) return;
    var c = colEl(); if (!c) return;
    for (var i = 0; i < c.children.length; i++) {
      if (c.children[i].classList && c.children[i].classList.contains('nt-sg-enlarge')) return;
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nt-sg-enlarge';
    btn.setAttribute('aria-label', 'Enlarge size guide');
    btn.innerHTML = ENLARGE_SVG + '<span>Enlarge</span>';
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openEnlarge(); });
    c.appendChild(btn);
  }

  /* Match the dtf-transfers-by-size-v2 design-note: the theme renders the pencil
     "Add a note for our designers" collapsible, but v2 presents the SAME
     .nt-design-note component as a CHECKBOX row -> set its text here, restyle the
     icon/chevron in nt-dtf-3col.css. The !== guard avoids redundant writes (and any
     observer churn) once the text already matches. Covers single + multi instances. */
  function styleDesignNote() {
    /* v4-FINAL copy (Owen 2026-07-17 parity) — this is the ONE copy writer on
       the page; the first-paint pseudos in nt-dtf-3col.css paint the same
       strings pre-swap and hand off on body.nt-notes-swapped below. */
    document.querySelectorAll('.nt-design-note__title strong').forEach(function (s) {
      if (s.textContent !== 'Need more than AI Edits? Add Design Notes') s.textContent = 'Need more than AI Edits? Add Design Notes';
    });
    document.querySelectorAll('.nt-design-note__sub').forEach(function (s) {
      if (s.textContent !== "We'll handle the rest before printing") s.textContent = "We'll handle the rest before printing";
    });
    if (document.body && !document.body.classList.contains('nt-notes-swapped')) document.body.classList.add('nt-notes-swapped');
    /* Pre-cut label -> read one-for-one with dtf-transfers-by-size-v2: bold title
       "Pre-cut my transfers", regular sub "Save time with individually cut transfers".
       .precut__label holds <strong>(title) + a direct text node (sub) + the info-icon
       link. The price lives in a SEPARATE strong.precut-cost sibling OUTSIDE
       .precut__label, so querySelector('strong') here never hits it -> price untouched. */
    document.querySelectorAll('.precut__label').forEach(function (lbl) {
      var strong = lbl.querySelector('strong');
      if (strong && strong.textContent.trim() !== 'Pre-cut my transfers') strong.textContent = 'Pre-cut my transfers';
      lbl.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && n.textContent.trim() && n.textContent.trim() !== 'Save time with pre-cut transfers') {
          n.textContent = ' Save time with pre-cut transfers';
        }
      });
    });
  }

  /* Move the "Preview: ..." label into file-preview so it floats in the bottom margin as
     a white pill (styled in nt-dtf-3col.css). The label is a sibling of file-preview inside
     .stickyBox; appended into file-preview (position:relative) it anchors to the checkerboard
     bottom. Re-applied each refresh; guarded so it moves once per preview (and never stolen
     from a file-preview it already lives in). */
  function placePreviewLabel() {
    document.querySelectorAll('.previewBlock_and_pricesTable file-preview, multi-upload file-preview').forEach(function (fp) {
      var pill = fp.querySelector(':scope > .previewText');
      if (!pill) {
        var pt = fp.parentElement && fp.parentElement.querySelector(':scope > .previewText');
        if (pt && !pt.closest('file-preview')) { pt.classList.add('nt-pv-pill'); fp.appendChild(pt); pill = pt; }
      }
      /* Drop the trailing "below." -> "Preview: The image will print as shown" (Justin). */
      if (pill && /\bbelow\b/i.test(pill.textContent)) { pill.innerHTML = pill.innerHTML.replace(/\s*below\.?/i, ''); }
    });
  }

  /* REVERTED (Justin): keep the "X% off" size-row discount as plain green text, NOT a
     pill. Strip the .nt-off-pill class on every refresh so any earlier-tagged span goes
     back to its default green font (a solid green pill barely dims under the cart's 36%
     backdrop, so it looked like it punched through — plain text blends into the dim). */
  function pillifyDiscount() {
    var pilled = document.querySelectorAll('.nt-off-pill');
    for (var i = 0; i < pilled.length; i++) pilled[i].classList.remove('nt-off-pill');
  }

  /* Boss layout (3-col sticky pricing) via a LIVE-SYNCED CLONE. Moving the real pricing
     breaks the engine's price population, so instead: keep the real pricing in place (CSS
     hides it off-screen but rendered, so the engine keeps filling it) and mirror its
     innerHTML into a .nt-pricing-clone that CSS places as the sticky condensed right
     column. Re-sync each refresh via a cheap string compare. Desktop only; on mobile (or
     no pricing) remove the clone + un-hide the real. */
  function clonePricing() {
    // Keep the REAL prices-table EXACTLY where the engine put it (moving it broke the
    // qty-change recalc -> $NaN, and re-rendered late). Hide it OFF-SCREEN but still
    // LAID OUT (position:absolute, off the side, real width) so its OWN collapse /
    // "View All" / tier-select logic runs correctly (e.g. View All hidden at 1-14).
    // Then mirror its already-collapsed DOM into a sticky col-3 clone. Desktop +
    // uploaded only; otherwise un-hide the real and drop the clone.
    var mp = document.querySelector('product-page.main-product') || document.querySelector('.main-product');
    if (!mp) return;
    var real = document.querySelector('.previewBlock_and_pricesTable .pricesTable');
    var clone = mp.querySelector(':scope > .nt-pricing-host');
    if (!isDesktop() || !document.body.classList.contains('image-uploaded') || !real) {
      if (clone) clone.remove();
      if (real) real.classList.remove('nt-pricing-real-off');
      return;
    }
    real.classList.add('nt-pricing-real-off');
    if (!clone) {
      clone = document.createElement('div');
      clone.className = 'nt-pricing-host';
      clone.setAttribute('aria-hidden', 'true');
      mp.appendChild(clone);
    }
    var html = real.innerHTML;
    if (clone.__ntLast !== html) {
      var copy = real.cloneNode(true);            // mirror the <prices-table> ELEMENT so the theme's scoped layout CSS applies
      copy.classList.remove('nt-pricing-real-off');
      copy.removeAttribute('id');
      clone.innerHTML = '';
      clone.appendChild(copy);
      ntCollapseClone(copy);
      var ngE = copy.querySelector('.print_perfect p em'); if (ngE) ngE.textContent = ngE.textContent.replace(/\.\s+/g, ' · ');   // tagline periods -> " · " middots, keep the "Ninja Guarantee:" label (Justin's reference)
      clone.__ntLast = html;
    }
  }

  // Replicate the native pricing-table collapse on the clone (the real table is parked
  // off-screen, where the engine's own collapse logic never runs). Rule from the design:
  // tiers BELOW the selected tier fold into a "View All"/"hide" toggle; the lowest tier
  // (1-14 selected) shows ALL rows with NO toggle. Driven by the engine-set .selected
  // class on the real (mirrored into the clone), so it tracks the quantity. Re-runs on
  // every clone re-sync.
  function ntCollapseClone(table) {
    var rows = [].slice.call(table.querySelectorAll('.pricesTable__item'));
    if (!rows.length) return;
    var nativeVA = table.querySelector('.pricesTable__table_viewAll');   // the theme's own View-All bar is inert in the clone (its handler isn't here) — drop it so only ours shows
    if (nativeVA) nativeVA.remove();
    var oldT = table.querySelector('.nt-va-toggle'); if (oldT) oldT.remove();   // no dupes across re-syncs
    var selIdx = 0;
    for (var i = 0; i < rows.length; i++) { if (/\bselected\b/.test(rows[i].className || '')) { selIdx = i; break; } }
    // Hide via setProperty(...,'important'): the theme's .pricesTable__item{display:flex!important}
    // beats a plain inline display:none, which is why the passed tier (e.g. 1-14) stayed exposed.
    rows.forEach(function (r) { r.style.removeProperty('display'); });
    if (selIdx <= 0) return;                    // lowest tier: nothing above it, no toggle
    var hidden = rows.slice(0, selIdx);
    hidden.forEach(function (r) { r.style.setProperty('display', 'none', 'important'); });
    var toggle = document.createElement('div');
    toggle.className = 'nt-va-toggle';
    toggle.setAttribute('role', 'button');
    toggle.innerHTML = '<span class="nt-va-chev" aria-hidden="true"></span><span class="nt-va-text">View All</span>';
    rows[0].parentNode.insertBefore(toggle, rows[0]);
    toggle.addEventListener('click', function () {
      var open = toggle.classList.toggle('nt-va-open');
      hidden.forEach(function (r) { if (open) r.style.removeProperty('display'); else r.style.setProperty('display', 'none', 'important'); });
      toggle.querySelector('.nt-va-text').textContent = open ? 'hide' : 'View All';
    });
  }

  // Qty is a bare .customQtyFile__qty text input with NO native +/- buttons, so
  // build a ▲/▼ stepper to match the W/H controls. Desktop only; torn down on
  // mobile. Changing the value fires input/change/keyup/blur (the engine recalcs
  // the hidden prices table on those), then we re-sync the visible pricing clone.
  function buildQtyStepper() {
    // Build a stepper for EVERY non-modal qty input — there are two (.customQtyFile__qty):
    // the Custom-Size tab's and the Popular-Size tab's. (Was only doing the first.)
    var all = document.querySelectorAll('.customQtyFile__qty');
    for (var i = 0; i < all.length; i++) { if (!all[i].closest('multi-upload')) ntQtyStepperFor(all[i]); }
  }
  function ntQtyStepperFor(qty) {
    var wrap = qty.parentElement;
    if (!wrap) return;
    if (!isDesktop()) {
      if (wrap.getAttribute('data-nt-qty') === '1') {
        wrap.removeAttribute('data-nt-qty');
        wrap.classList.remove('nt-qty-stepper');
        var old = wrap.querySelectorAll('.nt-qty-btn');
        for (var k = 0; k < old.length; k++) old[k].remove();
      }
      return;
    }
    if (wrap.getAttribute('data-nt-qty') === '1') return;
    wrap.setAttribute('data-nt-qty', '1');
    wrap.classList.add('nt-qty-stepper');
    function stepQty(dir) {
      var v = parseInt(qty.value, 10); if (isNaN(v)) v = 1;
      v = Math.max(1, v + dir);
      qty.value = v;
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
      try { qty.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true })); } catch (e) {}
      qty.dispatchEvent(new Event('blur', { bubbles: true }));
      setTimeout(clonePricing, 80);
      setTimeout(clonePricing, 350);
    }
    function mkBtn(dir, cls) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nt-qty-btn ' + cls;
      b.setAttribute('tabindex', '-1');
      b.setAttribute('aria-hidden', 'true');
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); stepQty(dir); });
      return b;
    }
    wrap.appendChild(mkBtn(1, 'nt-qty-plus'));
    wrap.appendChild(mkBtn(-1, 'nt-qty-minus'));
  }

  // Pre-cut box: when the "$X each" price shows (box checked) it squeezes .precut__label and its
  // subtext ("Save time with pre-cut transfers") wraps to a 3rd line (Justin). The subtext is a bare
  // TEXT NODE between the title <strong> and the info <a>, so there's no element for CSS to clamp —
  // wrap it in <span class="nt-precut-sub"> here so #E1 in nt-dtf-3col.css can hold it to one line.
  // Idempotent; runs for the single-upload box AND each multi-upload modal "Upload N" pre-cut box.
  function wrapPrecutSub() {
    var labels = document.querySelectorAll('precut .precut__label');
    for (var i = 0; i < labels.length; i++) {
      var lab = labels[i];
      if (lab.querySelector(':scope > .nt-precut-sub')) continue;
      var nodes = lab.childNodes;
      for (var j = 0; j < nodes.length; j++) {
        var nd = nodes[j];
        if (nd.nodeType === 3 && nd.textContent.replace(/\s/g, '').length > 3) {
          var span = document.createElement('span');
          span.className = 'nt-precut-sub';
          lab.insertBefore(span, nd);
          span.appendChild(nd);
          break;
        }
      }
    }
  }

  // C (Justin 6-25): on MOBILE/tablet (≤1199, matching the injector's isMobile) strip the trailing " Reviews"
  // word from the Yotpo bottom-line so the info row shows just stars + the number. precut-v3-injector's
  // formatReviewsText does this once but stops persisting (it early-returns with no observer when Yotpo is
  // already painted, and its observer hard-stops at 20s) — so a later Yotpo re-render restores "Reviews" on v2.
  // This re-applies every refresh()/observer tick. Idempotent (only writes when the text differs); commafies
  // to match the injector's output so the two never fight.
  function stripReviewsWordMobile() {
    if (window.innerWidth > 1199) return;
    // Scope to the info-row reviews ONLY (.product-text .has-bg-style--primary) — NOT the product-recommendation
    // cards, which also use .yotpo-sr-bottom-line-text inside .product-text (19 nodes total; this matches 1).
    // Stripping "Reviews" off a product card would read ambiguously ("★★★★★ 1,326"); the info row is the ask.
    var nodes = document.querySelectorAll('.product-text .has-bg-style--primary .yotpo-sr-bottom-line-summary .yotpo-sr-bottom-line-text-2-text, .product-text .has-bg-style--primary .yotpo-sr-bottom-line-text-2-text, .product-text .has-bg-style--primary .yotpo-sr-bottom-line-text');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i], m = (n.textContent || '').match(/(\d[\d,]*)\s*Reviews?/i);
      if (!m) continue;
      var target = String(m[1].replace(/,/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (n.textContent.trim() !== target) n.textContent = target;
    }
  }

  // Wrap the configurator's flat sections into titled white "step" cards (handoff
  // redesign, DESKTOP only). Idempotent — re-running is a no-op once wrapped, so the
  // refresh()/observer cadence can call it freely. Steps 1 & 4 are single elements
  // (tagged + titled in place); Steps 2 & 3 are contiguous ranges inside <next-element>
  // wrapped so several siblings read as one panel. DOM map (next-element children):
  // S1 .previewBlock_and_pricesTable | S2 tab-controls..sizes-blocks | S3
  // .designerNote_and_preCut..reward-point-block | S4 .grt-upsell (col-2 sibling).
  function buildStepCards() {
    if (!isDesktop()) return;
    var ne = document.querySelector('.dtfut next-element');
    if (!ne) return;
    function titleEl(html) { var t = document.createElement('div'); t.className = 'nt-step-title'; t.innerHTML = html; return t; }
    function tagStep(el, cls, title) {
      if (!el || el.classList.contains(cls)) return;
      el.classList.add('nt-step', cls);
      if (title && !el.querySelector(':scope > .nt-step-title')) el.insertBefore(titleEl(title), el.firstChild);
    }
    function wrapRange(cls, title, firstEl, lastEl) {
      if (!firstEl || !lastEl) return;
      if (firstEl.parentElement && firstEl.parentElement.classList.contains(cls)) return; // already wrapped
      var card = document.createElement('div');
      card.className = 'nt-step ' + cls;
      if (title) card.appendChild(titleEl(title));
      firstEl.parentNode.insertBefore(card, firstEl);
      var node = firstEl;
      while (node) { var next = node.nextSibling; card.appendChild(node); if (node === lastEl) break; node = next; }
    }
    tagStep(ne.querySelector(':scope > .previewBlock_and_pricesTable'), 'nt-step-1', '<span class="nt-step-n">Step 1:</span> Customize Your Image');
    wrapRange('nt-step-2', '<span class="nt-step-n">Step 2:</span> Choose your Transfer Sizes', ne.querySelector(':scope > tab-controls'), ne.querySelector(':scope > sizes-blocks'));
    wrapRange('nt-step-3', '<span class="nt-step-n">Step 3:</span> Final Touches', ne.querySelector(':scope > .designerNote_and_preCut'), ne.querySelector(':scope > .reward-point-block'));
    tagStep(document.querySelector('.product-text > .grt-upsell'), 'nt-step-4', '');   // Blanks card already has its own "Complete your order" header
    // Handoff puts the injected Buy-Now-Pay-Later row at the bottom of Step 3.
    var s3 = document.querySelector('.nt-step-3');
    var bnpl = document.querySelector('.product-text > .grt-payment-terms-extra-block');
    if (s3 && bnpl && bnpl.parentElement !== s3) s3.appendChild(bnpl);
  }

  // Phase 2: restructure the BG-removal block (.ai-ring) into the handoff "AI TOOLS" rail —
  // 3 stacked cards. Reuses the EXISTING controls (moves them, never rebuilds): the Remove
  // Background card holds label.switch.bgRemover + the .nt-bgr-tabs option thumbnails; the
  // Upscale card holds label.switch.superRes; the Edit card holds button.edit-with-ai.
  // Idempotent (skips once .nt-ai-rail exists). Layout/skin in nt-dtf-3col.css.
  // MOBILE "Your Image | Size Guide" tab bar. Ported from snippets/mobile-preview-size-guide-tabs.liquid,
  // which renders only in bySizeNew (the section v2 doesn't use), so v2 lacked the tabs entirely. Inject
  // .nt-mptabs as the first child of <product-page> (CSS in nt-dtf-3col.css gives it grid-column:1/-1 +
  // shows it ONLY ≤767 post-upload); the toggle keys off body.nt-mptab-preview / .nt-mptab-size-guide.
  // Idempotent; runs at all widths (CSS hides it on desktop). Click handler bound once. (Justin 6-24)
  function buildMpTabs() {
    var pp = document.querySelector('product-page');
    if (!pp || pp.querySelector(':scope > .nt-mptabs')) return;
    var bar = document.createElement('div');
    bar.className = 'nt-mptabs';
    bar.setAttribute('data-nt-mptabs', '');
    bar.setAttribute('role', 'tablist');
    bar.innerHTML =
      '<button type="button" class="nt-mptabs__tab is-active" data-nt-mptab="preview" role="tab" aria-selected="true">Your Image</button>' +
      '<button type="button" class="nt-mptabs__tab" data-nt-mptab="size-guide" role="tab" aria-selected="false">Size Guide</button>';
    pp.insertBefore(bar, pp.firstChild);
    if (!document.body.classList.contains('nt-mptab-size-guide')) document.body.classList.add('nt-mptab-preview');
    if (!window.__ntMpTabsClick) {
      window.__ntMpTabsClick = true;
      document.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('[data-nt-mptab]');
        if (!btn) return;
        var tab = btn.getAttribute('data-nt-mptab');
        document.body.classList.remove('nt-mptab-preview', 'nt-mptab-size-guide');
        document.body.classList.add('nt-mptab-' + tab);
        var tabs = document.querySelectorAll('.nt-mptabs__tab');
        for (var i = 0; i < tabs.length; i++) {
          var a = tabs[i].getAttribute('data-nt-mptab') === tab;
          tabs[i].classList.toggle('is-active', a);
          tabs[i].setAttribute('aria-selected', a ? 'true' : 'false');
        }
      });
    }
  }

  // MOBILE: move the Buy-More-Save selling cards (.nt-bms-v2-wrap) to directly BELOW the upload box.
  // v2's section orders them near the TOP of .product-text (DOM ~#13, ABOVE the .dtfut upload widget at
  // ~#19), and v1 shows them right UNDER the upload box. .product-text is display:block (CSS `order`
  // can't reposition), so move the node. CSS (#M10) force-shows them ≤767 pre-upload (theme.css's show
  // rule was being overridden on v2). Mobile + pre-upload only; post-upload the #M rules re-hide them.
  // Idempotent. innerWidth check runs correctly on the customer's phone (only MY MCP view is desktop). (Justin 6-24)
  function placeBmsCardsMobile() {
    if (window.innerWidth > 1023) return;   // mobile + tablet share the mobile view (Justin 6-24); 1024+ is the #R1/3-col desktop
    var b = document.body;
    if (b.classList.contains('image-uploaded') || b.classList.contains('nt-uploading')) return;
    var wrap = document.querySelector('.nt-bms-v2-wrap');
    var panel = document.querySelector('.dtfut__panel-wrap');   // the WHITE upload-box card
    if (!wrap || !panel) return;
    // move the cards INSIDE the white upload box (last child → below the dropzone panels), matching v1.
    // Idempotent (skip if already last child). dtfut may re-render the panel-wrap → the observer re-appends.
    if (wrap.parentElement !== panel || panel.lastElementChild !== wrap) panel.appendChild(wrap);
    // rewrite to v1's FULL copy. col2's .primary holds the LIVE countdown (injector updates it every tick)
    // so leave it — CSS prepends "Order in " via ::before. The rest are static; guards keep re-runs idempotent.
    var cols = wrap.querySelectorAll('.nt-bms-v2__col');
    function set(col, primary, caption) {
      if (!col) return;
      var p = col.querySelector('.nt-bms-v2__primary'), c = col.querySelector('.nt-bms-v2__caption');
      if (p && primary != null && p.textContent.trim() !== primary) p.textContent = primary;
      if (c && caption != null && c.textContent.trim() !== caption) c.textContent = caption;
    }
    set(cols[0], 'Save Up to 50% off', 'Buy More And Save');
    if (cols[1]) {
      // The caption is `["arrives" textNode, <span>Jun. 26</span>]` — the date span is populated async by
      // the injector. Replace ONLY the "arrives" text node (keep the span) so the live date survives:
      // "For Fastest Delivery " + <span>Jun. 26</span> → "For Fastest Delivery Jun. 26".
      var c1 = cols[1].querySelector('.nt-bms-v2__caption');
      if (c1) {
        var tn = null;
        for (var k = 0; k < c1.childNodes.length; k++) { var nd = c1.childNodes[k]; if (nd.nodeType === 3 && nd.textContent.trim()) { tn = nd; break; } }
        if (tn && tn.textContent.indexOf('Fastest') < 0) tn.textContent = 'For Fastest Delivery ';
      }
    }
    set(cols[2], 'No Minimums, Setup or Art Fees', 'The Ninja Guarantee');
  }

  function buildAiSidebar() {
    if (!isDesktop()) return;
    var ring = document.querySelector('.dtfut .ai-ring') || document.querySelector('.ai-ring');
    if (!ring) return;
    var existingRail = ring.querySelector('.nt-ai-rail');  // inside our <toggle-options> wrapper now, so not :scope >
    if (existingRail) {
      // Rail already built. The theme RE-RENDERS .nt-bgr-tabs into its default .ai-ring spot
      // when bg-processing finishes (the NEW banner + horizontal options reappear OUTSIDE the
      // card). Re-adopt the live tabs into the BG card (after the toggle) so the handoff layout
      // sticks. Idempotent: once parentNode===card, no further move → settles after one cycle.
      var bgCard = existingRail.querySelector('.nt-ai-card--bg');
      var liveTabs = ring.querySelector('.nt-bgr-tabs');
      if (bgCard && liveTabs && liveTabs.parentNode !== bgCard) {
        [].slice.call(bgCard.querySelectorAll('.nt-bgr-tabs')).forEach(function (t) { if (t !== liveTabs) t.remove(); });
        bgCard.appendChild(liveTabs);
      }
      return;
    }
    var tabs = ring.querySelector('.nt-bgr-tabs');
    var bgL = ring.querySelector('label.switch.bgRemover');
    var upL = ring.querySelector('label.switch.superRes');
    var edit = ring.querySelector('.edit-with-ai');
    var badge = ring.querySelector('.ai-badge');
    if (!bgL && !upL) return;
    var rail = document.createElement('div'); rail.className = 'nt-ai-rail';
    var eye = document.createElement('div'); eye.className = 'nt-ai-eyebrow'; eye.innerHTML = '<svg class="nt-ai-eyebrow__spark" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l1.9 6.1L20 10l-6.1 1.9L12 18l-1.9-6.1L4 10l6.1-1.9z"/></svg><span class="nt-ai-eyebrow__txt">AI TOOLS</span>'; rail.appendChild(eye);
    var c1 = document.createElement('div'); c1.className = 'nt-ai-card nt-ai-card--bg'; if (bgL) c1.appendChild(bgL); if (tabs) c1.appendChild(tabs); rail.appendChild(c1);
    var c2 = document.createElement('div'); c2.className = 'nt-ai-card nt-ai-card--up'; if (upL) c2.appendChild(upL); rail.appendChild(c2);
    if (edit) {
      var c3 = document.createElement('div'); c3.className = 'nt-ai-card nt-ai-card--edit'; c3.appendChild(edit);
      var sl = edit.querySelector(':scope > .nt-edit-slider'); if (sl) sl.remove();               // Edit is a BUTTON again (Justin), not a toggle
      var el2 = edit.querySelector('.edit-with-aiFlex'); if (el2 && el2.textContent.trim() !== 'Edit with AI') el2.textContent = 'Edit with AI';   // fully spelled out (Justin)
      rail.appendChild(c3);
    }
    if (badge) rail.appendChild(badge);
    // Wrap the WHOLE rail in a <toggle-options> (display:contents → zero layout effect) so the engine's
    // `toggle-options .bgRemover/.superRes .toggleOption` selectors keep matching (the toggles are
    // descendants of it) WITHOUT inserting a node between each card and its label — that earlier broke
    // the label's flex (text stopped wrapping, toggle overflowed). <toggle-options> isn't a registered
    // element, so it's inert; display:contents keeps it out of the box tree.
    var toWrap = document.createElement('toggle-options'); toWrap.style.setProperty('display', 'contents', 'important'); toWrap.appendChild(rail); ring.appendChild(toWrap);
  }

  // AI IMAGE EDITOR dropdown (Justin 7-10) — DESKTOP single-upload rail on dtf-transfers
  // (by-size-middle-scroll) + dtf-transfers-by-size-v2 (power-builder) + uv-dtf-
  // stickers-decals-by-size (uv-by-size-middle-scroll, added Justin 7-10). Collapses the rail's two action pills — Edit with AI and
  // Recolor — into ONE dashed "✦ AI Image Editor ⌄" trigger with a 2-row menu:
  //   Edit with Prompt — "Describe any change in words"  → proxies the real Edit pill
  //   Recolor Image    — "Swap any color in your design" → proxies the real Recolor pill
  // Image Effects (third row) opens the imgix-filter modal in studio-recolor.js.
  // The REAL buttons stay in the DOM: nt-dtf-3col.css hides their cards via
  // .nt-ai-rail:has(.nt-ai-card--aied), and the menu rows re-dispatch clicks into them.
  // Proxy targets are LOAD-BEARING: the AI-edit modal opens off a delegated
  // $("body").on('click','.edit-with-ai .edit-with-aiFlex') (bySize_popular.js /
  // pdp_transferBySize.js) so we must click the .edit-with-aiFlex CHILD, not the button;
  // Recolor opens off studio-recolor.js's document-capture .nt-recolor-btn listener, so a
  // plain .click() on the button reaches it. If this builder never runs, the :has() gate
  // never matches and the two pills show exactly as before. Idempotent per rail; the
  // builder view (pb-builder-open) keeps its flat per-tile toolbars — we never touch
  // .nt-ai-actions, only rail cards.
  var AIED_TEMPLATES = /(^|\s)template-product-(by-size-middle-scroll|uv-by-size-middle-scroll|power-builder)(\s|$)/;
  // One shared trigger+menu template for BOTH surfaces (single-upload rail card and
  // builder-view tile hosts) so the two can never drift apart visually.
  var AIED_HTML =
    '<button type="button" class="nt-aied-trigger" aria-haspopup="true" aria-expanded="false">' +
      '<svg class="nt-aied-spark" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2 13.6 9.1 20.5 11 13.6 12.9 12 20 10.4 12.9 3.5 11 10.4 9.1 12 2Z"/><path d="M19 3 19.7 5.3 22 6 19.7 6.7 19 9 18.3 6.7 16 6 18.3 5.3 19 3Z" opacity=".75"/><path d="M5 14 5.6 15.7 7.3 16.3 5.6 16.9 5 18.6 4.4 16.9 2.7 16.3 4.4 15.7 5 14Z" opacity=".55"/></svg>' +
      '<span class="nt-aied-label">AI Edit Tools</span>' +
      '<svg class="nt-aied-chev" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 6l4 4 4-4"/></svg>' +
    '</button>' +
    '<div class="nt-aied-menu" role="menu">' +
      '<button type="button" class="nt-aied-item" role="menuitem" data-nt-aied="edit">' +
        '<span class="nt-aied-item__icon nt-aied-item__icon--edit"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.6 3.2a1.9 1.9 0 0 1 2.7 2.7l-8.1 8.1-3.6.9.9-3.6 8.1-8.1z"/><path d="M3.5 17h13"/></svg></span>' +
        '<span class="nt-aied-item__text"><span class="nt-aied-item__title">Edit with AI</span><span class="nt-aied-item__sub">Describe what you want to change</span></span>' +
      '</button>' +
      '<button type="button" class="nt-aied-item" role="menuitem" data-nt-aied="recolor">' +
        '<span class="nt-aied-item__icon nt-aied-item__icon--recolor"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 2.2c-4.3 0-7.8 3.2-7.8 7.3 0 4 3.5 7.3 7.8 7.3.8 0 1.4-.6 1.4-1.4 0-.4-.1-.7-.4-1-.2-.3-.4-.6-.4-1 0-.8.7-1.4 1.5-1.4h1.7c2.4 0 4.3-1.8 4.3-4.1C18 4.9 14.4 2.2 10 2.2z"/><circle cx="6.3" cy="7.4" r="1.15" fill="currentColor" stroke="none"/><circle cx="10" cy="5.6" r="1.15" fill="currentColor" stroke="none"/><circle cx="13.7" cy="7.4" r="1.15" fill="currentColor" stroke="none"/><circle cx="5.6" cy="11.4" r="1.15" fill="currentColor" stroke="none"/></svg></span>' +
        '<span class="nt-aied-item__text"><span class="nt-aied-item__title">Swap Colors</span><span class="nt-aied-item__sub">Swap any color in your design</span></span>' +
      '</button>' +
      '<button type="button" class="nt-aied-item" role="menuitem" data-nt-aied="effects">' +
        '<span class="nt-aied-item__icon nt-aied-item__icon--fx"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="10" cy="10" r="7.8"/><circle cx="10" cy="6.3" r="1.5"/><circle cx="6.5" cy="8.9" r="1.5"/><circle cx="7.9" cy="13" r="1.5"/><circle cx="12.1" cy="13" r="1.5"/><circle cx="13.5" cy="8.9" r="1.5"/></svg></span>' +
        '<span class="nt-aied-item__text"><span class="nt-aied-item__title">Image Filters</span><span class="nt-aied-item__sub">One-tap filters like B&amp;W &amp; more</span></span>' +
      '</button>' +
    '</div>';
  // Shared open/close + proxy-click wiring, bound ONCE at document level (bubble) so
  // engine re-renders never orphan the handlers, and every host — rail card or builder
  // tile — shares it. Proxy scope resolves per host: the surrounding .nt-ai-actions
  // (builder tile — keeps each tile's click on ITS OWN Edit/Recolor buttons, so the
  // engine's closest('uploaded-files-block') block-targeting still works) else the
  // rail. Re-entrancy is safe: the proxied .click() re-enters this listener, but its
  // target is never a .nt-aied-item, so it only ever reaches the close branch.
  function wireAied() {
    if (window.__ntAiedWired) return;
    window.__ntAiedWired = true;
    // The menu PORTALS to <body> as position:fixed while open. Two reasons this can't
    // stay a plain absolute popover: (1) the builder's tile list is an overflow-y:auto
    // scrollport (power-builder.css .upload-area) that clips any absolute child at its
    // edges — no z-index can save it; (2) "menu has to be on top of everything"
    // (Justin 7-10) — fixed-on-body out-paints every stacking context for good, rail
    // included. Any scroll closes the menu (native-select behavior), so the fixed box
    // can never visibly drift from its trigger. On close the node re-homes into its
    // host and the inline styles reset, so the class CSS (display:none) takes over.
    function openHost(h) {
      var menu = h.querySelector(':scope > .nt-aied-menu');
      var trg = h.querySelector('.nt-aied-trigger');
      if (!menu || !trg) return;
      var r = trg.getBoundingClientRect();
      // The builder tiles run under CSS zoom (power-builder.css:1499 —
      // uploaded-files-block{zoom:.8} on power-builder + uv-by-size-middle-scroll).
      // Chromium returns rects already multiplied by zoom (visual px), so the
      // body-fixed menu lands on its trigger; WebKit returns css-space rects,
      // which dropped the menu ~25% below the trigger on Safari (Owen
      // 2026-07-20). Detect which space the rect is in by comparing it with
      // offsetWidth (always local css px): scale≈1 while cumulative zoom≠1
      // means css-space → multiply into visual px. Chrome measures scale≈zoom
      // → vis stays 1 (no double-scaling).
      var zoomAcc = 1, ze = trg;
      while (ze && ze !== document.body) {
        var czv = parseFloat(getComputedStyle(ze).zoom);
        if (czv && czv !== 1) zoomAcc *= czv;
        ze = ze.parentElement;
      }
      var vis = 1;
      if (zoomAcc !== 1 && trg.offsetWidth) {
        var rectScale = r.width / trg.offsetWidth;
        if (Math.abs(rectScale - 1) < 0.02) vis = zoomAcc;
      }
      h.classList.add('nt-aied-open');
      trg.setAttribute('aria-expanded', 'true');
      h.__ntMenu = menu;
      menu.__ntHost = h;
      // proxy scope resolved NOW (while the menu still knows its host): the tile's own
      // .nt-ai-actions — so each tile's menu clicks ITS OWN Edit/Recolor buttons and the
      // engine's closest('uploaded-files-block') block-targeting keeps working — else
      // the single-upload rail.
      menu.__ntScope = h.closest('.nt-ai-actions') || h.closest('.nt-ai-rail') || null;
      menu.style.setProperty('display', 'block', 'important');
      menu.style.setProperty('position', 'fixed', 'important');
      // align left edges; clamp so the 230px box keeps an 8px viewport gutter
      var left = Math.max(8, Math.min(Math.round(r.left * vis), window.innerWidth - 238));
      menu.style.setProperty('left', left + 'px', 'important');
      menu.style.setProperty('z-index', '2147483000', 'important');
      document.body.appendChild(menu);
      // vertical: below the trigger by default, but FLIP ABOVE when the menu would
      // fall past the fold — scroll closes the menu, so an off-screen menu would be
      // unreachable (adversarial-review finding: last visible builder tile's trigger
      // routinely sits within ~120px of the viewport bottom). Measured after append
      // so offsetHeight is real.
      var mh = menu.offsetHeight || 0;
      var top = Math.round(r.bottom * vis + 8);
      if (top + mh > window.innerHeight - 8) top = Math.round(r.top * vis - 8 - mh);
      if (top < 8) top = 8;
      menu.style.setProperty('top', top + 'px', 'important');
    }
    function closeHost(h) {
      h.classList.remove('nt-aied-open');
      var b = h.querySelector('.nt-aied-trigger');
      if (b) b.setAttribute('aria-expanded', 'false');
      var menu = h.__ntMenu;
      if (menu) {
        menu.style.cssText = '';
        h.appendChild(menu);
        h.__ntMenu = null;
        menu.__ntHost = null;
        menu.__ntScope = null;
      }
    }
    // sweep portaled menus whose host an engine re-render deleted mid-open — the
    // builders recreate host+menu fresh, so a stray node must not linger on <body>.
    // Exposed on window so the theme's MutationObserver tick (via aiedTidy) can run
    // it too: user events alone left an orphaned menu floating at z-2147483000 until
    // the next click/scroll/Escape (adversarial-review finding).
    window.__ntAiedTidy = function () {
      var strays = document.querySelectorAll('body > .nt-aied-menu');
      for (var j = 0; j < strays.length; j++) {
        var h = strays[j].__ntHost;
        if (!h || !document.documentElement.contains(h)) strays[j].parentNode.removeChild(strays[j]);
      }
    };
    function closeAll(except) {
      var open = document.querySelectorAll('.nt-aied-host.nt-aied-open');
      for (var i = 0; i < open.length; i++) if (open[i] !== except) closeHost(open[i]);
      window.__ntAiedTidy();
    }
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var trg = t.closest('.nt-aied-trigger');
      if (trg) {
        var c = trg.closest('.nt-aied-host');
        if (!c) return;
        var wasOpen = c.classList.contains('nt-aied-open');
        closeAll(null);   // multiple hosts exist in the builder — only one menu open at a time
        if (!wasOpen) openHost(c);
        return;
      }
      var item = t.closest('.nt-aied-item');
      if (item) {
        var menuEl = item.closest('.nt-aied-menu');
        var scope = (menuEl && menuEl.__ntScope) || document;
        // if the engine re-rendered the host away mid-open, the stored scope is a
        // DETACHED subtree — a proxied click there never reaches the delegated
        // openers (silent no-op) or could retarget another surface via the document
        // fallback. Just close; the rebuilt tile has a fresh working dropdown.
        if (scope !== document && !document.documentElement.contains(scope)) { closeAll(null); return; }
        // The engine can re-render a pill OUTSIDE the .nt-ai-actions wrapper (cloned
        // with data-nt-rcl, so studio-recolor never re-wraps it) — if the wrapper
        // query misses, retry across the whole tile so the proxy still lands on THIS
        // tile's button (never another tile's).
        var findBtn = function (sel) {
          var b = scope.querySelector(sel);
          if (b) return b;
          var tile = scope.closest && scope.closest('uploaded-files-block, .multiupload-rebuild-tools-inner');
          return tile ? tile.querySelector(sel) : null;
        };
        if (item.getAttribute('data-nt-aied') === 'edit') {
          var eb = findBtn('.edit-with-ai:not(.nt-recolor-btn)');
          var flex = eb && eb.querySelector('.edit-with-aiFlex');
          if (flex) flex.click(); else if (eb) eb.click();
        } else if (item.getAttribute('data-nt-aied') === 'effects') {
          // no proxy pill for this one — open the Image Effects modal
          // (studio-recolor.js) directly, per-tile in the builder
          var blockEl = scope !== document && scope.closest ? scope.closest('uploaded-files-block') : null;
          var bn = blockEl ? blockEl.getAttribute('block-no') : null;
          if (window.ntImageEffects && window.ntImageEffects.open) window.ntImageEffects.open(bn);
        } else {
          var rb = findBtn('.nt-recolor-btn');
          if (rb) rb.click();
        }
        closeAll(null);
        return;
      }
      if (!t.closest('.nt-aied-host') && !t.closest('.nt-aied-menu')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
    document.addEventListener('scroll', function () { closeAll(null); }, true);
    // resize/rotation reflows the trigger while the menu is pinned at stale fixed
    // coordinates (and a 1024px breakpoint crossing hides the host but the portaled
    // menu's inline !important styles beat every guard) — close, same as scroll.
    window.addEventListener('resize', function () { closeAll(null); });
  }
  // Runs window.__ntAiedTidy (the orphaned-portal sweep wireAied installs) from the
  // refresh/observer chains — no-op until the first dropdown is built.
  function aiedTidy() { if (window.__ntAiedTidy) window.__ntAiedTidy(); }
  function buildAiEditorDropdown() {
    if (!isDesktop() || !AIED_TEMPLATES.test(document.body.className)) return;
    var rail = document.querySelector('.nt-ai-rail');
    if (!rail || rail.querySelector('.nt-ai-card--aied')) return;
    var editCard = rail.querySelector('.nt-ai-card--edit');
    if (!editCard) return;   // the trigger proxies the Edit pill — wait until the rail adopted it
    var card = document.createElement('div');
    card.className = 'nt-ai-card nt-ai-card--aied nt-aied-host';
    card.innerHTML = AIED_HTML;
    rail.insertBefore(card, editCard);
    wireAied();
  }
  // BUILDER-view tiles (Justin 7-10): same collapse on the power-builder multi-image
  // builder — Large + Compact on desktop AND the mobile builder (Justin 7-10 mobile
  // ask), so NO width gate here. Each uploaded-files-block tile's .nt-ai-actions
  // (built by studio-recolor.js: the tile's real Edit with AI pill + its flat Recolor
  // pill) gets ONE trigger+menu host appended; CSS hides the two pills via :has()
  // (JS-failure-safe, same pattern as the rail) and the shared handler proxy-clicks
  // them per tile. Waits until BOTH pills exist so the collapse never half-applies
  // mid-injection. NOTE: no multi-upload-wrapper exclusion here — the pb builder
  // itself renders INSIDE multi-upload-wrapper.multiUpload (power-builder.css), so
  // that check silently skipped every tile (bug, Justin 7-10). The template gate +
  // uploaded-files-block ancestor already scope this to the right surface; the
  // dtf-transfers modal never passes the power-builder template gate.
  // Inline-hide every Edit/Recolor pill inside `root` except our own dropdown host.
  // display:none is set as an INLINE !important, which no stylesheet can out-rank —
  // the engine kept re-rendering pills in unpredictable spots (outside .nt-ai-actions,
  // outside the toolbar, cloned WITH data-nt-rcl so studio-recolor never re-wraps
  // them) and every CSS :has() scoping attempt missed one (Justin 7-10 ×2). The
  // MutationObserver re-runs the builders after each re-render, so fresh pills get
  // swept within a tick. Hidden pills still take proxied .click()s — visibility is
  // irrelevant to dispatched events — so the dropdown keeps working through them.
  function aiedSweepPills(root) {
    var pills = root.querySelectorAll('.edit-with-ai, .nt-recolor-btn');
    for (var i = 0; i < pills.length; i++) {
      if (pills[i].closest('.nt-aied-host')) continue;
      pills[i].style.setProperty('display', 'none', 'important');
    }
  }
  function buildAiEditorDropdownTiles() {
    if (!/(^|\s)template-product-(power-builder|uv-by-size-middle-scroll)(\s|$)/.test(document.body.className)) return;
    var wraps = document.querySelectorAll('uploaded-files-block .nt-ai-actions');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (w.querySelector(':scope > .nt-aied-host')) continue;
      if (!w.querySelector('.edit-with-ai:not(.nt-recolor-btn)') || !w.querySelector('.nt-recolor-btn')) continue;
      var host = document.createElement('div');
      host.className = 'nt-aied-host nt-aied-tile';
      host.innerHTML = AIED_HTML;
      w.appendChild(host);
      wireAied();
    }
    // sweep ONLY tiles that have a host — if the dropdown never built, the pills
    // must stay visible (same degrade contract as the CSS :has rules)
    var tiles = document.querySelectorAll('uploaded-files-block');
    for (var j = 0; j < tiles.length; j++) {
      if (tiles[j].querySelector('.nt-aied-host')) aiedSweepPills(tiles[j]);
    }
  }
  // MOBILE single-upload flat toolbar (Justin 7-10): below 1024 there is no rail —
  // the toolbar is the flat .multiupload-rebuild-tools-inner bar, and studio-recolor's
  // flat path wraps its Edit with AI + Recolor pills in a .nt-ai-actions. Collapse
  // that pair into the same dropdown host. Mobile ONLY: on desktop the rail card owns
  // the collapse, and injecting here would fight studio-recolor's stranded-wrapper
  // cleanup (it unwraps any .nt-ai-actions whose Edit pill the rail adopted away).
  // Excludes the multi-upload modal (multi-upload-wrapper, out of scope) and the
  // builder tiles (handled by buildAiEditorDropdownTiles above).
  function buildAiEditorDropdownFlat() {
    if (isDesktop() || !AIED_TEMPLATES.test(document.body.className)) return;
    var wraps = document.querySelectorAll('.multiupload-rebuild-tools-inner .nt-ai-actions');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (w.closest('multi-upload-wrapper') || w.closest('uploaded-files-block')) continue;
      if (!w.querySelector(':scope > .nt-aied-host')) {
        if (!w.querySelector('.edit-with-ai:not(.nt-recolor-btn)') || !w.querySelector('.nt-recolor-btn')) continue;
        var host = document.createElement('div');
        host.className = 'nt-aied-host nt-aied-flat';
        host.innerHTML = AIED_HTML;
        w.appendChild(host);
        wireAied();
      }
      // same engine-re-render insurance as the tiles: inline-hide stray pills across
      // this host's whole toolbar (only ever runs once a host exists in it)
      var bar = w.closest('.multiupload-rebuild-tools-inner');
      if (bar) aiedSweepPills(bar);
    }
  }

  // Once bg-removal works, the engine re-renders the Remove Background toggle with its label as a BARE
  // text node (no .nt-bgr-toggle-label span). The wrap CSS (flex:1; white-space:normal) then has nothing
  // to target, so the text stays on one line (min-width:auto won't shrink) and shoves the slider off the
  // 140px card. Re-wrap the bare text in the span so it stacks to 2 lines again. Idempotent.
  function wrapBgToggleText() {
    var lbl = document.querySelector('.nt-ai-card--bg label.switch.bgRemover');
    if (!lbl || lbl.querySelector('.nt-bgr-toggle-label')) return;
    for (var i = 0; i < lbl.childNodes.length; i++) {
      var n = lbl.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) {
        var span = document.createElement('span'); span.className = 'nt-bgr-toggle-label'; span.textContent = n.textContent.trim();
        n.parentNode.replaceChild(span, n); return;
      }
    }
  }

  // Edit-with-AI is now a TOGGLE (Justin): its existing click opens the AI-edit modal and
  // flips the toggle ON; closing the modal (Escape / a close button / backdrop click) flips
  // it OFF. (The button has no inspectable modal handle, so close-detection is generic —
  // verify against the real modal.) Idempotent via the data flag.
  function wireEditToggle() {
    var edit = document.querySelector('.nt-ai-card--edit .edit-with-ai');
    if (!edit || edit.getAttribute('data-nt-edit') === '1') return;
    edit.setAttribute('data-nt-edit', '1');
    edit.addEventListener('click', function () {
      var card = edit.closest('.nt-ai-card--edit'); if (!card) return;
      // its own listener opens the modal; reflect the on-state (toggle if it re-closes)
      setTimeout(function () { card.classList.toggle('nt-edit-on'); }, 0);
    });
    if (!window.__ntEditCloseWired) {
      window.__ntEditCloseWired = 1;
      var off = function () { var c = document.querySelector('.nt-ai-card--edit.nt-edit-on'); if (c) c.classList.remove('nt-edit-on'); };
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') off(); });
      document.addEventListener('click', function (e) {
        var t = e.target; if (!t || !t.closest) return;
        if (t.closest('.close, .modal-close, .md-modal__close, .video-popup__close, [data-dismiss], [data-close]') ||
            /(^|[^a-z])(backdrop|overlay|modal-bg|modal__bg)/.test((typeof t.className === 'string' ? t.className : '').toLowerCase())) off();
      }, true);
    }
  }

  // Precut subtitle copy: "Save time with individually cut transfers" -> "...pre-cut transfers"
  // (Justin). Text node lives in .precut__label alongside the heading. Idempotent.
  function fixPrecutText() {
    var lbl = document.querySelector('.precut__label'); if (!lbl) return;
    [].slice.call(lbl.childNodes).forEach(function (n) {
      if (n.nodeType === 3 && /individually cut/i.test(n.textContent)) n.textContent = n.textContent.replace(/individually cut/i, 'pre-cut');
    });
  }

  // Step-2 size tabs: the workspace builds <tab-controls> labels (Custom Size |
  // Popular Size) WITHOUT the leading glyphs v1 dtf-transfers shows. v1's glyphs
  // live as background-images on the (now hidden) #size_selection .tab_header
  // anchors, so reuse those EXACT data-URIs: read each, hand it to the matching
  // label as --nt-tab-icon (consumed by nt-dtf-3col.css's masked ::before), and
  // tag the label .nt-has-icon so the pseudo only paints once the glyph is known.
  // Keyed off label text (not order) so it's robust; idempotent per tick. Covers
  // every <tab-controls> on the page, so multi-upload blocks get glyphs too.
  function applyTabIcons() {
    try {
      var cust = document.querySelector('#size_selection a[href="#custom_size"]');
      var pop  = document.querySelector('#size_selection a[href="#popular_size"]');
      if (!cust || !pop) return;
      var custBg = getComputedStyle(cust).backgroundImage;
      var popBg  = getComputedStyle(pop).backgroundImage;
      if (!custBg || custBg === 'none' || !popBg || popBg === 'none') return;
      [].slice.call(document.querySelectorAll('tab-controls label.tabLink')).forEach(function (l) {
        var bg = /popular/i.test(l.textContent || '') ? popBg : custBg;
        if (l.style.getPropertyValue('--nt-tab-icon') !== bg) l.style.setProperty('--nt-tab-icon', bg);
        l.classList.add('nt-has-icon');
      });
    } catch (e) {}
  }

  /* v4-FINAL notes position (Owen 2026-07-17): the single-flow notes card
     moves from the Step-3 designerNote_and_preCut grid into .stickyBox (the
     Step-1 column) as its LAST child — image → AI tools → notes, the v4
     stacked read. Node MOVE (snippet's document-level toggle + the engine's
     textarea read survive); idempotent per tick like every builder here. */
  function placeDesignNote() {
    var note = document.querySelector('.designerNote_and_preCut .nt-design-note');
    var sticky = document.querySelector('.previewBlock_and_pricesTable .stickyBox');
    if (note && sticky && note.parentElement !== sticky) sticky.appendChild(note);
  }

  function refresh() {
    injectButton();
    ensurePreviewObserver();
    applyPreviewMargin();
    arrangeBgOptions();
    styleDesignNote();
    placeDesignNote();
    placePreviewLabel();
    pillifyDiscount();
    clonePricing();
    buildQtyStepper();
    buildStepCards();
    fixPrecutText();
    buildAiSidebar();
    buildAiEditorDropdown();
    buildAiEditorDropdownTiles();
    buildAiEditorDropdownFlat();
    aiedTidy();
    buildMpTabs();
    placeBmsCardsMobile();
    wrapPrecutSub();
    stripReviewsWordMobile();
    applyTabIcons();
    if (enlarged) { var s = sgEl(); if (s && !s.classList.contains('nt-sg-enlarged')) openEnlarge(); }
    else fitInPage();
  }

  function init() {
    refresh();
    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      // buildMpTabs + placeBmsCardsMobile on resize too: crossing the 1024 line (desktop↔tablet/mobile) is a
      // pure resize (no DOM mutation) so the observer won't fire. Both are idempotent/width-guarded — tabs are
      // CSS-hidden >1023, and placeBmsCardsMobile no-ops >1023 — so the forward drag (desktop→tablet) lands the
      // mobile view without a reload. (Reload/device-mode already worked via refresh().) (Justin 6-24)
      rt = setTimeout(function () { applyPreviewMargin(); arrangeBgOptions(); buildQtyStepper(); buildMpTabs(); placeBmsCardsMobile(); if (enlarged) openEnlarge(); else fitInPage(); }, 150);
    });
    // The dimension rulers update on size changes (W/H inputs, popular-size
    // picks). The engine updates them async (sometimes ~seconds later), so after
    // any size input poll briefly until the new size lands — applyPreviewMargin
    // is guarded, so polls are cheap and idempotent. (The subtree observer also
    // catches engine-driven changes, but this is the reliable backstop.)
    var dimPoll = null, dimN = 0;
    function dimTick() {
      dimN = 0;
      clearInterval(dimPoll);
      dimPoll = setInterval(function () { applyPreviewMargin(); arrangeBgOptions(); if (++dimN >= 16) clearInterval(dimPoll); }, 250);
    }
    // arrangeBgOptions SYNCHRONOUSLY on the toggle change (before the polled
    // dimTick) so the card relocates left the instant BG is checked — paired with
    // the :has() CSS that hides it in .ai-wrap, there's no flash under the image.
    document.addEventListener('input', function () { arrangeBgOptions(); dimTick(); }, true);
    document.addEventListener('change', function (e) {
      arrangeBgOptions(); dimTick();
      // show the main-preview loader the instant BG removal is switched on
      if (e && e.target && e.target.id === 'bgRemover') {
        if (e.target.checked) startBgLoad(); else previewLoading(false);
      }
    }, true);
    try {
      var c = colEl();
      if (c && window.ResizeObserver) new ResizeObserver(function () { if (!enlarged) fitInPage(); }).observe(c);
    } catch (_) {}
    // Each BG-removal option tab resolves to ~118px via height:auto though its visible content
    // (thumb + "Option N" label) ends ~18px higher — a phantom reserve no DOM/pseudo inspection
    // surfaces (confirmed: not flex, not a text node, not a pseudo). Size each tab to its label's
    // actual bottom so the labels sit tight and we save vertical height (Justin). Re-runs every
    // mutation (the engine re-renders tabs); idempotent once a tab is sized.
    function tightenOptionTabs() {
      // SCOPE to the single-upload redesign rail only. The multi-upload modal renders the same
      // .nt-bgr-tab cards but in a layout where the label sits at the card BOTTOM — measuring
      // label.bottom each tick then setting it as the height pushed the label lower and grew the
      // card without bound (the runaway in multi-upload). Never touch tabs outside our rail or
      // inside a multi-upload, and cap the height so it can never run away again. (Justin)
      var scope = document.querySelector('.nt-ai-rail');
      if (!scope) return;
      var tabs = scope.querySelectorAll('.nt-bgr-tab');
      for (var i = 0; i < tabs.length; i++) {
        var tab = tabs[i];
        if (tab.closest('multi-upload, .multiupload, [class*="multiupload"]')) continue;
        var lbl = tab.querySelector('.nt-bgr-tab__label');
        if (!lbl) continue;
        var h = Math.ceil(lbl.getBoundingClientRect().bottom - tab.getBoundingClientRect().top) + 2;
        if (h > 24 && h < 200) { tab.style.setProperty('height', h + 'px', 'important'); tab.style.setProperty('overflow', 'hidden', 'important'); }
      }
    }
    var mt = null;
    // buildStepCards is EAGER here too (guarded/idempotent like its neighbors): the
    // debounced refresh() below loses its clearTimeout race indefinitely on
    // power-builder — the page mutates more often than the 200ms window, so every
    // pending refresh gets cleared before it fires and the Step 3 card (whose anchors
    // mount AFTER init's one direct refresh() call) never wrapped (Justin 7-10,
    // traced live: 15 schedules / 0 runs in 6s).
    var mo = new MutationObserver(function () { clonePricing(); buildQtyStepper(); buildStepCards(); buildAiSidebar(); buildAiEditorDropdown(); buildAiEditorDropdownTiles(); buildAiEditorDropdownFlat(); aiedTidy(); buildMpTabs(); placeBmsCardsMobile(); wrapBgToggleText(); tightenOptionTabs(); applyTabIcons(); clearTimeout(mt); mt = setTimeout(refresh, 200); });   // clonePricing + buildQtyStepper eagerly (both guarded/idempotent) so the col-3 clone AND the qty ▲▼ stepper fill the instant they render — no empty gap, no arrowless qty flash (#11)
    try { mo.observe(document.body, { childList: true, subtree: true }); } catch (_) {}
    [400, 1200, 2500].forEach(function (d) { setTimeout(function () { if (!enlarged) fitInPage(); }, d); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* #1 — hide the marketing header DURING the upload loader too. The running-ninja loader
   (.ldl-ninja) is VISIBLE only while processing, but body.image-uploaded isn't set until it
   finishes — and the loader element PERSISTS hidden in the DOM afterward, so :has() can't gate
   on it. Toggle body.nt-uploading off the loader's actual visibility; CSS hides the header on it. */
(function () {
  function anyVisible(sel) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      var e = els[i]; if (e.offsetParent === null) continue;
      var r = e.getBoundingClientRect(); if (r.width > 2 && r.height > 2) return true;
    }
    return false;
  }
  var wasUploading = false;
  function tick() {
    var up = anyVisible('.ldl-ninja') || anyVisible('.loadingPercent__counter');
    document.body.classList.toggle('nt-uploading', up);
    // When the upload loader first appears, snap the viewport to the very top so the customer sees
    // the top of the layout (not wherever an auto-focus landed). Rising edge + a couple of delayed
    // re-scrolls to beat any late auto-focus/scroll the engine fires. (Justin)
    if (up && !wasUploading) {
      try { window.scrollTo(0, 0); } catch (e) {}
      setTimeout(function () { try { window.scrollTo(0, 0); } catch (e) {} }, 120);
      setTimeout(function () { try { window.scrollTo(0, 0); } catch (e) {} }, 350);
    }
    wasUploading = up;
  }
  function start() { tick(); setInterval(tick, 200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* #2-FOUC — the engine's BG-panel header-row ("NEW · 3 BG options · Hide") flashes for a frame
   before the CSS hide applies (its :has(#bgRemover:checked) recalc lags the panel paint). Hide it
   synchronously via MutationObserver the instant it's added. Safe unconditionally: when BG is OFF
   the whole .nt-bgr-tabs panel is already display:none, so there's no banner to preserve here. */
(function () {
  function hide() {
    var rows = document.querySelectorAll('.nt-ai-card--bg .nt-bgr-tabs__header-row');
    for (var i = 0; i < rows.length; i++) rows[i].style.setProperty('display', 'none', 'important');
  }
  function start() {
    hide();
    try { new MutationObserver(hide).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
